import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Chip,
    Box,
    Divider,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { getLeaveProgressColors } from '../../../../utils/constants';
import { Icons } from '../../../../utils/GlobalIcons';

export const LeaveInfo = ({ leave }) => {

    return (
        <Card
            sx={{
                maxWidth: 420,
                margin: '24px auto',
                borderRadius: 3,
                boxShadow: 6,
                p: 2,
                backgroundColor: '#f9fafb',
            }}
        >
            <CardContent>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <PersonIcon className='field-icon' />
                    <Typography variant="h6" fontWeight={600}>
                        {leave.EmployeeName}
                    </Typography>
                </Box>

                <Divider sx={{ mb: 2 }} />

                <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <EventNoteIcon fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary">
                                <strong>Leave Type:</strong> {leave.LeaveType}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <CalendarMonthIcon fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary">
                                <strong>From:</strong> {leave.LeaveFrom}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <CalendarMonthIcon fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary">
                                <strong>To:</strong> {leave.LeaveTo}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <InfoIcon fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary" mr={1}>
                                <strong>Status:</strong>
                            </Typography>
                            <Chip
                                label={leave.Status}
                                size="small"
                                sx={{ fontWeight: 500, color: getLeaveProgressColors(leave.Leavestatus).color, background: getLeaveProgressColors(leave.Leavestatus).backgroundColor }}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Icons.Description fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary">
                                <strong>Reason:</strong> {leave?.LeaveReason || 'N/A'}
                            </Typography>
                        </Box>
                    </Grid>



                </Grid>
                <Divider sx={{ my: 2 }} />
                {/* Section: Approval Info */}
                <Typography sx={{ color: 'rgb(0 0 0 / 87%)', fontWeight: 600, mb: 1 }}
                >
                    Approval Info
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1.2}>
                            <PersonIcon fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary">
                                <strong>Approved By:</strong> {leave?.ApprovedBy || 'N/A'}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1.2}>
                            <Icons.Description fontSize="small" className='field-icon' />
                            <Typography variant="body2" color="text.secondary">
                                <strong>Remark:</strong> {leave?.Leaveremark || 'N/A'}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
